import {Component} from '@angular/core';
import {CrudDetails} from '../../../../shared/components/crud-details';
import {ActivatedRoute, Router} from '@angular/router';
import {CrudLogsService} from '../../../../shared/services/crud-logs.service';
import {Log} from '../../../../models/sharedinterface';

@Component({
  selector: 'app-logs-details',
  templateUrl: './logs-details.component.html',
  styleUrls: ['./logs-details.component.scss']
})
export class LogsDetailsComponent extends CrudDetails {

  constructor(
    protected httpcrud: CrudLogsService, // Specific
    protected route: ActivatedRoute,
    protected router: Router,
  ) {
    super(httpcrud, route, router);
  }

  protected initSpecificDetailsConfig(): void {
    this.redirecturl = '/admin/logs';
  }

  public getFormattedData(data: string): string {
    if (!data) {
      return 'Not available';
    }
    return JSON.stringify(JSON.parse(data), undefined, 2);
  }

  public getUsernameElement(log: Log): string {
    if (log.username === 'anonymous') {
      return '<em>@' + log.username + '</em>';
    } else {
      return '<em>@<a href="/admin/users/' + log.userid + '">' + log.username + '</a></em>';
    }
  }

  public getLogLabel(log: Log): string {
    return '<div class="badge bg-' + log.level + '">' + log.level + '</div>';
  }
}
